import { defineMessages } from 'react-intl';

export default defineMessages({
  GoToSearch: {
    id: 'Details.GoToSearch',
    defaultMessage: 'Go to search',
  },
  JobCategory: {
    id: 'Details.Data.Category',
    defaultMessage: 'Job Category',
  },
  Location: {
    id: 'Details.Data.Location',
    defaultMessage: 'Location',
  },
  Id: {
    id: 'Details.Data.Id',
    defaultMessage: 'Req. ID',
  },
  JobType: {
    id: 'Details.Data.JobType',
    defaultMessage: 'Job Type',
  },
  ApplyForJob: {
    id: 'Details.ApplyForJob',
    defaultMessage: 'Apply',
  },
  JobDescription: {
    id: 'Details.Data.JobDescription',
    defaultMessage: 'The role',
  },
  JobResponsibilities: {
    id: 'Details.Data.JobResponsibilities',
    defaultMessage: 'Responsibilities',
  },
  JobRequirements: {
    id: 'Details.Data.JobRequirements',
    defaultMessage: 'Requirements',
  },
  JobCompensationAndBenefits: {
    id: 'Details.Data.JobCompensationAndBenefits',
    defaultMessage: 'Compensation and Benefits',
  },
  EVerify: {
    id: 'Details.EVerify',
    defaultMessage:
      'Tesla participates in the <a class="tds-link" href="/careers/e-verify?redirect=no" target="_blank">E-Verify Program</a>',
  },
});
